import { render, staticRenderFns } from "./DailyWork.vue?vue&type=template&id=63745188&"
import script from "./DailyWork.vue?vue&type=script&lang=js&"
export * from "./DailyWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports